import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector, batch } from 'react-redux';

import {
  loadRequiredActionsRequest,
  validateProspectsRequest,
  resetProspects,
} from '../store/requiredActions/requiredActions.actions';
import { getGiftHashId } from '../store/data/data.selectors';
import {
  getRALoaded,
  getRALoading,
  getRequiredActions,
  getErrors,
  getIsValidated,
  getValidatedProspects,
} from '../store/requiredActions/requiredActions.selectors';
import { setProspects as setGiftFlowProspects } from '../store/giftFlow/giftFlow.actions';
import useTrackRecipient from '../../../hooks/useTrackRecipient';

export default onAfterValidate => {
  const dispatch = useDispatch();
  const trackEvent = useTrackRecipient();

  const hashId = useSelector(getGiftHashId);
  const raLoaded = useSelector(getRALoaded);
  const raLoading = useSelector(getRALoading);
  const requiredActions = useSelector(getRequiredActions);
  const errors = useSelector(getErrors);
  const isValidated = useSelector(getIsValidated);
  const validatedProspects = useSelector(getValidatedProspects);

  const loadRequiredActions = useCallback(() => dispatch(loadRequiredActionsRequest({ hashId })), [dispatch, hashId]);

  const submitProspects = useCallback(
    prospects => {
      dispatch(validateProspectsRequest({ hashId, prospects }));
    },
    [dispatch, hashId],
  );

  useEffect(() => {
    dispatch(resetProspects());
  }, [dispatch]);

  useEffect(() => {
    if (!raLoaded) {
      loadRequiredActions();
    }
  }, [loadRequiredActions, raLoaded]);

  useEffect(() => {
    if (isValidated) {
      batch(() => {
        dispatch(setGiftFlowProspects(validatedProspects));
        onAfterValidate();
        dispatch(resetProspects());
        trackEvent('Required Info Page - Prospects sent', { prospects: validatedProspects });
      });
    }
  }, [dispatch, isValidated, validatedProspects, trackEvent, onAfterValidate]);

  return {
    raLoaded,
    raLoading,
    errors,
    requiredActions,
    loadRequiredActions,
    submitProspects,
  };
};
